import React, { FC, ReactElement } from 'react';
import { Field } from 'formik';
import { camelize, humanize } from 'inflection';

import {
  WizardSubmitButton,
  WizardPage,
  WizardPreviousButton
} from '@buyside/components/presentation/Form/Wizard/Wizard';
import RadioField from '@buyside/components/presentation/Form/Field/RadioField/radioField';
import PageHeader from '@buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/pageHeader';
import { generateRadios } from '@buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/util';
import { previousInvestmentsSchema } from '@buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/validations';

const { accreditationQuestionnaire } = require('buyside/util/constantsFromRails.json');

import styles from '@buyside/components/presentation/AccreditedInvestorProfilePage/Pages/pageStyles.scss';

const PreviousInvestments: FC<{
  isLoading: boolean;
  validationSchema: typeof previousInvestmentsSchema;
}> = ({ isLoading, validationSchema }): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      <PageHeader subHeader="Previous Investments" />
      {accreditationQuestionnaire.map((questionObject: { question: string; names: string[] }) => (
        <div className={styles.field} key={questionObject.question}>
          {questionObject.names.length !== 1 && (
            <>
              <label className={styles.label}>{questionObject.question}</label>
              {questionObject.names.map((name: string) => (
                <div className={styles.field} key={name}>
                  <label>{humanize(name)}</label>
                  <Field
                    component={RadioField}
                    name={camelize(name, true)}
                    options={generateRadios(name)}
                  />
                </div>
              ))}
            </>
          )}
        </div>
      ))}
      <div className={styles.actionsContainer}>
        <WizardPreviousButton previousText="Back" />
        <WizardSubmitButton submitText="Submit" isLoading={isLoading} />
      </div>
    </WizardPage>
  );
};

export default PreviousInvestments;
